import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

import { ErrorService, isPausedAccess } from 'app/services/error.service';

@Injectable()
export class PausedInterceptor implements HttpInterceptor {
  constructor(private router: Router, private errorService: ErrorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next
      .handle(req)
      .map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body.success === false) {
          if (isPausedAccess(event.body.returnCode.label)) {
            this.errorService.error = event.body.returnCode;
            this.errorService.error.code = event.body.returnCode.label;
            this.router.navigate(['/error']);
            return Observable.empty();
          }
        }
        return event;
      })
      .catch((err: any) => {
        return Observable.throw(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/http-interceptors/paused-interceptor.ts